module.exports = __webpack_public_path__ + "media/images/benefits_expire_inactive-385d0356.svg";